import React, {useEffect, useState} from 'react';
import ConfigService from "../../services/config";
import {useNavigate} from "react-router-dom";
import {Checkbox, FormControl, FormControlLabel, FormGroup, Grid, TextField} from '@mui/material';
import {makeStyles} from "@mui/styles";
import {Controller, useFormContext} from "react-hook-form";
import {
  changePackagingType,
  changeLoadingType,
  getPackagingTypes,
  getLoadingTypes,
  getVehicleTypes,
  getVehicleWeights
} from "../../lib";
import {Button, colorLabel, fontFamily, Label, SubTitle} from '../'

const useStyles = makeStyles(() => ({
  saveButtonAlign: {
    textAlign: "right"
  },
  saveButton: {
    width: 120,
    height: 37,
    marginTop: 160,
    fontSize: 13,
    fontFamily,
    fontWeight: 500,
  },
  formWidth: {
    width: 570,
  },
  vehicleTypesWidth: {
    width: 140,
  },
  vehicleWeightsWidth: {
    width: 100,
  },
  packagingTypeWidth: {
    width: 80
  },
  profileContainer: {
    width: 1050,
  },
  rowLabel: {
    color: colorLabel,
  },
  firstRow: {
    marginTop: 17,
  },
  secondForm: {
    marginTop: 20
  }
}));

export default function ProfilePreferred(props: any) {
  const classes = useStyles();

  const vehicleTypes = getVehicleTypes();
  const vehicleWeights = getVehicleWeights();
  const packagingTypes = getPackagingTypes();
  const loadingTypes = getLoadingTypes();
  const unloadingTypes = getLoadingTypes();

  const navigate = useNavigate();
  const {control, setValue} = useFormContext();

  const [countTypes, setCountTypes] = useState(new Array(vehicleTypes.length).fill(false));
  const [countWeights, setCountWeights] = useState(new Array(vehicleWeights.length).fill(false));

  const [packagingType, setPackagingType] = useState<string>("etc");
  const [loadingType, setLoadingType] = useState<string>("forklift");
  const [unloadingType, setUnloadingType] = useState<string>("forklift");
  const [optionMixedLoading, setOptionMixedLoading] = useState<boolean>(false);
  const [item, setItem] = useState<string>("");
  const [requestNoteForDriver, setRequestNoteForDriver] = useState<string>("");
  const [requestNoteForAdmin, setRequestNoteForAdmin] = useState<string>("");

  useEffect(() => {
    async function getOption() {
      try {
        const optionService = new ConfigService(navigate);
        const config = await optionService.inquiry();
        for (let i = 0; i < vehicleTypes.length; i++) {
          if (config.vehicleTypes.includes(vehicleTypes[i])) {
            countTypes[i] === false ? countTypes[i] = true : countTypes[i] = false;
            const newArrayTypes = [...countTypes]
            setCountTypes(newArrayTypes);
          }
        }

        for (let i = 0; i < vehicleWeights.length; i++) {
          if (config.vehicleWeights.length === 0) return;
          if (config.vehicleWeights.includes(vehicleWeights[i])) {
            countWeights[i] === false ? countWeights[i] = true : countWeights[i] = false;
            const newArrayWeights = [...countWeights]
            setCountWeights(newArrayWeights)
          }
        }
        setPackagingType(config.packagingType);
        setLoadingType(config.loadingType);
        setUnloadingType(config.unloadingType);
        setOptionMixedLoading(config.optionMixedLoading);
        setItem(config.item);
        setRequestNoteForDriver(config.requestNoteForDriver);
        setRequestNoteForAdmin(config.requestNoteForAdmin);
      } catch (e) {
        console.error('failed to handle getOption', e)
      }
    }

    queueMicrotask(getOption)
  }, []);

  function postOption(requestData: any) {
    try {
      const optionService = new ConfigService(navigate);
      optionService.modify(requestData);
      alert("자주 쓰는 옵션이 저장되었습니다.");
    } catch (e) {
      console.error('failed to handle settlements:', e);
    }
  }

  function countCheckTypes(i: number, checked: boolean) {
    if (checked) {
      const copyContentsArray = [...countTypes];
      copyContentsArray[i] = true;
      let cnt = countTypes.filter((v) => v === true).length;
      if (cnt >= 4) {
        alert("4개까지 선택 가능합니다.");
        copyContentsArray[i] = false;
      }
      setCountTypes(copyContentsArray);
    } else {
      const copyContentsArray = [...countTypes];
      copyContentsArray[i] = false;
      setCountTypes(copyContentsArray);
    }
  }

  function countCheckWeight(i: number, checked: boolean) {
    if (checked) {
      const copyContentsArray = [...countWeights];
      copyContentsArray[i] = true;
      let cnt = countWeights.filter((v) => v === true).length;
      if (cnt >= 4) {
        alert("4개까지 선택 가능합니다.");
        copyContentsArray[i] = false;
      }
      setCountWeights(copyContentsArray);
    } else {
      const copyContentsArray = [...countWeights];
      copyContentsArray[i] = false;
      setCountWeights(copyContentsArray);
    }
  }

  async function saveData() {
    const filterVehicleTypes = vehicleTypes.filter((v, i) => countTypes[i] === true);
    const filterVehicleWeight = vehicleWeights.filter((v, i) => countWeights[i] === true);
    const requestData = {
      vehicleTypes: filterVehicleTypes,
      vehicleWeights: filterVehicleWeight,
      optionMixedLoading: optionMixedLoading,
      packagingType: packagingType,
      loadingType: loadingType,
      unloadingType: unloadingType,
      item: item,
      requestNoteForDriver: requestNoteForDriver,
      requestNoteForAdmin: requestNoteForAdmin
    }
    await postOption(requestData);
  }

  return (
    <div className={classes.profileContainer}>
      <SubTitle>{'자주 쓰는 옵션'}</SubTitle>
      <Grid container>
        <Grid item>
        <Grid container direction={'column'}>
        <Grid item>
          <Grid container direction={'column'} spacing={2}>
            <Grid item className={classes.firstRow}>
              <div>
                <Label required={false}>{'차량 (4개선택)'}</Label>
              </div>
              <FormControl component="fieldset">
                <FormGroup aria-label="position" row className={classes.formWidth}>
                  <Controller
                    name={"checkTypes"}
                    defaultValue={"0"} // control 로 감싸줘야 form 에서 데이터를 가져감
                    render={() => (
                      <>
                        {
                          vehicleTypes.map((v: any, i: number) => {
                            return (
                              <div className={classes.vehicleTypesWidth} key={i}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      value={0} // The DOM API casts this to a string.
                                      onChange={(e: any) => {
                                        countCheckTypes(i, e.target.checked)
                                      }}
                                      color="primary"
                                      checked={countTypes[i]}
                                    />
                                  }
                                  label={v}
                                />
                              </div>
                            )
                          })
                        }
                      </>
                    )}
                  />
                </FormGroup>
              </FormControl>
            </Grid>
            <Grid item>
              <div>
                <Label required={false}>{'차중 (4개선택)'}</Label>
              </div>
              <FormControl component="fieldset">
                <FormGroup aria-label="position" row className={classes.formWidth}>
                  <Controller
                    name={"checkWeight"}
                    defaultValue={"0"} // control 로 감싸줘야 form 에서 데이터를 가져감
                    render={() => (
                      <>
                        {
                          vehicleWeights.map((v: any, i: number) => {
                            return (
                              <div className={classes.vehicleWeightsWidth} key={i}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      value={props.value} // The DOM API casts this to a string.
                                      onChange={(e: any) => {
                                        countCheckWeight(i, e.target.checked);
                                      }
                                      }
                                      color="primary"
                                      checked={countWeights[i]}
                                    />
                                  }
                                  label={v + "톤"}
                                />
                              </div>
                            )
                          })
                        }
                      </>
                    )}
                  />
                </FormGroup>
              </FormControl>
            </Grid>


            <Grid item>
              <div>
                <Label required={false}>{"포장방법"}</Label>
              </div>
              <FormControl component="fieldset">
                <FormGroup aria-label="position" row className={classes.formWidth}>
              <Controller  // control 로 감싸줘야 form 에서 데이터를 가져감
                control={control}
                name={"packagingType"}
                defaultValue={"0"}
                render={() => (
                  <>
                    {packagingTypes.map((v: any, i: number) => {
                      return(
                        <div className={classes.packagingTypeWidth} key={i}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                value={v} // The DOM API casts this to a string.
                                onChange={(e: any) => {
                                  if(e.target.value === "pt" && loadingType === "hand") {
                                    setLoadingType("forklift")
                                  }
                                  if(e.target.value === "pt" && unloadingType === "hand") {
                                    setUnloadingType("forklift")
                                  }

                                  if(e.target.value === "box" && (loadingType === "forklift" || loadingType === "crane")) {
                                    setLoadingType("hand")
                                  }
                                  if(e.target.value === "box" && (unloadingType === "forklift" || unloadingType === "crane")) {
                                    setUnloadingType("hand")
                                  }

                                  setValue("packagingType", e.target.value)
                                  setPackagingType(e.target.value)
                                }}
                                color="primary"
                                checked={packagingType === v}
                              />
                            }
                            label={changePackagingType(v)}
                          />
                        </div>
                      )
                    })}
                  </>
                )}/>
                </FormGroup>
              </FormControl>
            </Grid>

            <Grid item>
              <Grid container>
                <Grid item>
                  <Grid item>
                    <div>
                      <Label required={false}>{"상차방법"}</Label>
                    </div>
                    <FormControl component="fieldset">
                      <FormGroup aria-label="position" row className={classes.formWidth}>
                        <Controller  // control 로 감싸줘야 form 에서 데이터를 가져감
                          control={control}
                          name={"loadingType"}
                          render={() => (
                            <>
                              {loadingTypes.filter(v => {
                                if(packagingType === "pt" && v === "hand") return false;
                                if(packagingType === "box" && (v === "forklift" || v === "crane")) return false;

                                return true;
                              }).map((v,i)=>{

                                return(
                                  <div className={classes.packagingTypeWidth} key={i}>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          value={v} // The DOM API casts this to a string.
                                          onChange={(e: any) => {
                                            setValue("loadingType", e.target.value)
                                            setLoadingType(e.target.value)
                                          }
                                          }
                                          color="primary"
                                          checked={loadingType === v}
                                        />
                                      }
                                      label={changeLoadingType(v)}
                                    />
                                  </div>
                                )
                              })}
                            </>
                          )}/>
                      </FormGroup>
                    </FormControl>
                  </Grid>

                  <Grid item>
                    <div>
                      <Label required={false}>{"하차방법"}</Label>
                    </div>
                    <FormControl component="fieldset">
                      <FormGroup aria-label="position" row className={classes.formWidth}>
                        <Controller  // control 로 감싸줘야 form 에서 데이터를 가져감
                          control={control}
                          name={"unloadingType"}
                          defaultValue={""}
                          render={({field}) => (
                            <>
                              {unloadingTypes.filter((v: any) => {
                                if(packagingType === "pt" && v === "hand") return false;
                                if(packagingType === "box" && (v === "forklift" || v === "crane")) return false;

                                return true;
                              }).map((v,i)=>{

                                return(
                                  <div className={classes.packagingTypeWidth} key={i}>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          {...field}
                                          value={v} // The DOM API casts this to a string.
                                          onChange={(e: any) => {
                                            setValue("unloadingType", e.target.value)
                                            setUnloadingType(e.target.value)
                                          }
                                          }
                                          color="primary"
                                          checked={unloadingType === v}
                                        />
                                      }
                                      label={changeLoadingType(v)}
                                    />
                                  </div>
                                )
                              })}
                            </>
                          )}/>
                      </FormGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <div>
                <Label required={false}>{"기타"}</Label>
              </div>
              <Controller  // control 로 감싸줘야 form 에서 데이터를 가져감
                control={control}
                name={"optionMixedLoading"}
                render={({field}) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...field}
                        checked={optionMixedLoading}
                        value={field.value} // The DOM API casts this to a string.
                        onChange={(e: any) => {
                          const val = e.target.checked;
                          field.onChange(e);
                          setValue("optionMixedLoading", val); // DOM API 가 string 으로 컨버팅 하기 때문에 값을 다시 넣어준다.
                          setOptionMixedLoading(val);
                        }}
                        color="primary"
                      />
                    }
                    label="혼적가능"
                  />
                )}
              />
            </Grid>
          </Grid>


        </Grid>
        
      </Grid>
        </Grid>

        <Grid item>
          <Grid container direction="column">
            <Grid item className={classes.firstRow}>
              <div>
                <Label required={false}>{"품목"}</Label>
              </div>
              <TextField sx={{mt: 1, width: 400}} value={item} onChange={(e: any) => setItem(e.target.value)}/>
            </Grid>

            <Grid item className={classes.firstRow}>
              <div>
                <Label required={false}>{"기사님 요청사항"}</Label>
              </div>
              <TextField sx={{mt: 1, width: 400}} multiline rows={3} value={requestNoteForDriver} onChange={(e: any) => setRequestNoteForDriver(e.target.value)}/>
            </Grid>

            <Grid item className={classes.firstRow}>
              <div>
                <Label required={false}>{"운영자 요청사항"}</Label>
              </div>
              <TextField sx={{mt: 1, width: 400}} multiline rows={3} value={requestNoteForAdmin} onChange={(e: any) => setRequestNoteForAdmin(e.target.value)}/>
            </Grid>
            <Grid item>
          <div className={classes.saveButtonAlign}>
            <Button onClick={saveData} className={classes.saveButton}>
              저장
            </Button>
          </div>
        </Grid>
            </Grid>

          </Grid>
          
      </Grid>

      
    </div>
  )
    ;
}
